import styled, { css } from 'styled-components';
import { tokens, palette } from '@plataforma/components';
import { Button as ButtonComponent } from 'junto-ui';

export const Wrapper = styled.section`
  height: 184px;
  width: 864px;
  display: grid;
  grid-template-columns: ${({ columnsWidths }) => columnsWidths};
  border-radius: 4px;
  ${({ backgroundColor }) => `background-color: ${palette[backgroundColor]};`}

  & > div:nth-child(2) {
    display: flex;
    flex-flow: column;
    align-self: center;
  }
`;

export const Collumn = styled.div`
  height: 100%;
`;

export const BackgroundImage = styled.img`
  .carousel .slide & {
    ${({ left, top, rotate, invert }) => css`
      position: absolute;
      width: 123px;
      height: 62px;
      margin-left: ${left}px;
      margin-top: ${top}px;
      z-index: 1;
      transform: rotate(${rotate}deg) ${() => (invert ? 'rotateY(180deg)' : '')};
    `};
  }
`;

export const Image = styled.img`
  .carousel .slide & {
    ${({ height, width, left, top }) => css`
      height: ${height}px;
      width: ${width}px;
      margin-left: ${left}px;
      margin-top: ${top}px;
      z-index: 1;
    `};
  }
`;
export const Text = styled.p`
  ${({ typography, color, width, left, top }) => css`
    ${tokens.font[typography]};
    color: ${palette[color]};
    width: ${width}px;
    margin-left: ${left}px;
    margin-top: ${top}px;
    z-index: 1;
  `};
`;

export const Button = styled(ButtonComponent)`
  ${({ variant }) =>
    variant === 'outlined' &&
    css`
      background-color: transparent;
    `}

  ${({ typography, color, width, left, top }) => css`
    background-color: transparent;
    ${tokens.font[typography]};
    color: ${palette[color]};
    width: ${width}px;
    margin-left: ${left}px;
    margin-top: ${top}px;
    z-index: 1;
  `};
`;

export const LinkButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  text-align: start;

  ${({ typography, color, width, left, top }) => css`
    ${tokens.font[typography]};
    color: ${palette[color]};
    width: ${width}px;
    margin-left: ${left}px;
    margin-top: ${top}px;
    z-index: 1;
  `};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
